import React from 'react';
import {Button, Flex, Modal} from "antd";
import CustomButton from "../../../../../components/UI/CustomButton/CustomButton";
import './is-already-registered-modal.scss'
import {useNavigate} from "react-router";
import {useSendVerificationCompanyMailMutation} from "../../../../../redux/API/companySlice";
import {useDispatch} from "react-redux";
import {addSignUpData} from "../../../../../redux/businessSlice";

interface Company {
  companyName: string;
  companyEmail: string;
  companyAddress: string;
  imageUrl: string;
  placeId: string;
  link: string;
}

interface VerificationRequestModalProps {
  visible: boolean;
  onClose: () => void;
  setIsVerificationRequestToOwnerOpen: Function;
  company: Company
}

const IsAlreadyRegisteredModal = ({ visible, onClose, company, setIsVerificationRequestToOwnerOpen }: VerificationRequestModalProps) => {
  console.log(company)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sendVerificationCompanyMail] = useSendVerificationCompanyMailMutation();

  const handleAnotherCompanyClick = () => {
    dispatch(
      addSignUpData({
        company: company
      }))
    onClose();
    navigate('../business')
  }

  const handleRegisterClick = () => {
    onClose();
    navigate('../business/email')
  }

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      className="IsAlreadyRegisteredModal"
    >
      <Flex vertical justify={"center"} align={"center"} gap={'50px'} className="IsAlreadyRegisteredModal__content">
        <Flex vertical gap={'13px'} className="IsAlreadyRegisteredModal__header">
          <h2 className="IsAlreadyRegisteredModal__header__title">This company is already registered</h2>
          <p className="IsAlreadyRegisteredModal__header__description">
            The “{company.companyName}” is already registered in the app. You can only become a part of it
          </p>
          <Button
            className="IsAlreadyRegisteredModal__header__link"
            type={"link"}
            onClick={() => {
              sendVerificationCompanyMail({
                name: company.companyName,
                email: company.companyEmail
              });
              setIsVerificationRequestToOwnerOpen(true);
              onClose();
            }}
          >
            Or if you are the owner click here
          </Button>
        </Flex>
        <Flex gap={'30px'} vertical className="IsAlreadyRegisteredModal__button">
          <CustomButton text={'Register as a staff member'} disable={false} onClick={() => handleRegisterClick()}/>
          <Button
            className="IsAlreadyRegisteredModal__button__link"
            type={"link"}
            onClick={() => handleAnotherCompanyClick()}
          >
            Choose another company
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default IsAlreadyRegisteredModal;